<template>
  <div class="list bg-white">
    <header class="f-b-c">
      <el-input style="width:300px" placeholder="活动名称/优惠码" v-model="parameter.searchContent">
        <template slot="append">
          <el-button type="primary" icon="el-icon-search" @click="resetPage()" />
        </template>
      </el-input>
      <el-button type="primary" @click="addPromo">创建优惠码</el-button>
    </header>
    <section>
      <el-table
        v-loading="loading"
        :data="list"
        height="100%"
        style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          width="50">
        </el-table-column>
        <el-table-column
          prop="couponName"
          label="活动名称">
        </el-table-column>
        <el-table-column
          prop="couponCode"
          label="优惠码">
          <template slot-scope="{row}">
            <div class="pointer" style="color:#99C41C" @click="jumpDetail(row)">{{ row.couponCode }}</div>
          </template>
        </el-table-column>
        <el-table-column
          width="200px"
          prop="startTime"
          label="活动时间">
          <template slot-scope="{row}">
            <div>{{ row.startTime | dateFormat }}</div>
            <div>{{ row.endTime | dateFormat }}</div>
          </template>
        </el-table-column>
        <el-table-column
          width="260px"
          prop="name"
          label="优惠规则">
          <template slot-scope="{row}">
            <div v-if="row.discountRule === 4">
              <div>优惠码类型：推广码</div>
              <div>充值金额：{{row.rechargeAmount}}USD</div>
              <div>优惠码数量：{{ row.couponCodeNum === 2147483647 ? '不限': row.couponCodeNum }}</div>
            </div>
            <template v-else>
              <div v-if="row.discountRule === 3">
                {{ row.couponName }}
              </div>
              <div v-else>
                {{ row.discountCondition === 1 ? `消费满${row.satisfyNum}件` : row.discountCondition === 2 ? `消费满${row.satisfyAmount}USD` : '无门槛' }}，
                {{ row.discountRule === 1 ? `折扣${row.discountPercent}%` : `减价${row.discountFixed}USD` }}
              </div>
              <div>优惠码数量：{{ row.couponCodeNum === 2147483647 ? '不限': row.couponCodeNum }}</div>
              <div>每人限用：{{ row.perPersonNum === 2147483647 ? '不限': row.perPersonNum}}</div>
              <div>与其他活动优惠叠加使用：{{ row.useInConjunction ? '是' : '否'}}</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          prop="usedNum"
          label="已消耗/剩余">
          <template slot-scope="{row}">
            <div>{{ row.usedNum+row.occupiedNum }}/{{ row.couponCodeNum === 2147483647 ? '不限': (row.couponCodeNum - row.usedNum - row.occupiedNum) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="活动状态">
          <template slot-scope="{row}">
            {{ status[row.status] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="操作">
          <template slot-scope="{row}">
            <el-popconfirm v-if="row.status !== 0" title="确定提前结束这个活动吗？" icon-color="red" @confirm="setCouponStatus(row)">
              <el-button slot="reference" type="text" size="small" style="color:red;margin-right:10px">提前结束</el-button>
            </el-popconfirm>
            <el-button v-if="row.status !== 0" @click="edit(row)" type="text" size="small">编辑</el-button>
            <el-button @click="jumpDetail(row)" type="text" size="small">数据明细</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <footer>
      <el-pagination background :current-page="parameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="parameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </footer>
    <Add ref="addPromoCode" @addSuccess="getList()" />
  </div>
</template>

<script>
import Add from './Add.vue'
import API from "@/api";
export default {
  components: { Add },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      parameter: {
        pageNumber: 1,
        pageSize: 20,
        status: undefined,
        searchContent: undefined
      },
      status: {
        0: '已结束',
        1: '正在进行',
        2: '未开始'
      }
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    getList(status) {
      this.loading = true
      if (status) {
        this.parameter.pageNumber = 1
        this.parameter.status = status === '-1' ? undefined : status
      }
      API.getCouponList(this.parameter).then(({ data }) => {
        this.list = data.list
        this.total = data.total
      }).finally(() => {
        this.loading = false
      })
    },
    addPromo() {
      this.$refs.addPromoCode.show()
    },
    resetPage() {
      this.parameter.pageNumber = 1
      this.getList()
    },
    handleSizeChange(size) {
      this.parameter.pageSize = size
      this.getList()
    },
    handleCurrentChange(page) {
      this.parameter.pageNumber = page
      this.getList()
    },
    // 提前结束
    setCouponStatus(row) {
      API.setCouponStatus({ id: row.id, status: 0, couponCode: row.couponCode }).then(res => {
        this.$message.success(res.message)
        this.getList()
      })
    },
    jumpDetail(row) {
      this.$router.push({ path: '/operation/promoCode/detail', query: { id: row.id }})
    },
    edit(row) {
      this.$refs.addPromoCode.show(row, 'edit')
    }
  }
}
</script>

<style  lang="scss" scoped>
.list {
  section{
    height: calc(100vh - 260px);
    margin-top: 10px;
  }
  footer{
    padding: 10px 0;
    display: flex;
    justify-content: flex-end;
  }
}
</style>